import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import MetisMenu from "metismenujs";

import { useDispatch } from "react-redux";

import { setZero } from "../../store/data/actions";

import SimpleBar from "simplebar-react";

const SidebarContent = (props) => {
  const dispatch = useDispatch();
  return (
    <div id="sidebar-menu">
      <ul className="metismenu list-unstyled" id="side-menu">
        <li className="menu-title">Main</li>

        <li>
          <Link to="/dashboard" className="waves-effect">
            <i className="ti-home"></i>
            <span>Dashboard</span>
          </Link>
        </li>

        <li>
          <Link to="/#" className="has-arrow waves-effect">
            <i className="ti-user"></i>
            <span>Users</span>
          </Link>
          <ul className="sub-menu">
            <li>
              <Link
                to="/registred-users"
                onClick={() => {
                  dispatch(setZero());
                }}
              >
                Registered Users
              </Link>
            </li>
            <li>
              <Link
                to="/facebook-users"
                onClick={() => {
                  dispatch(setZero());
                }}
              >
                Facebook Users
              </Link>
            </li>
            <li>
              <Link
                to="/google-users"
                onClick={() => {
                  dispatch(setZero());
                }}
              >
                Google Users
              </Link>
            </li>
            <li>
              <Link
                to="/email-users"
                onClick={() => {
                  dispatch(setZero());
                }}
              >
                Email Users
              </Link>
            </li>
            <li>
              <Link
                to="/unsubscribe-users"
                onClick={() => {
                  dispatch(setZero());
                }}
              >
                Unsubscribe Users
              </Link>
            </li>
          </ul>
        </li>

        <li>
          <Link to="/#" className="has-arrow waves-effect">
            <i className="ti-palette"></i>
            <span>Contests / Events</span>
          </Link>
          <ul className="sub-menu">
            <li>
              <Link
                to="/contest-list"
                onClick={() => {
                  dispatch(setZero());
                }}
              >
                Contest / Event List
              </Link>
            </li>
            <li>
              <Link
                to="/active-contest"
                onClick={() => {
                  dispatch(setZero());
                }}
              >
                Active Contest
              </Link>
            </li>
            <li>
              <Link
                to="/contest-by-user"
                onClick={() => {
                  dispatch(setZero());
                }}
              >
                User Contests
              </Link>
            </li>
            <li>
              <Link to="/create-contest">Create Contest / Event</Link>
            </li>
          </ul>
        </li>

        <li>
          <Link
            to="/entries"
            className="waves-effect"
            onClick={() => {
              dispatch(setZero());
            }}
          >
            <i className="ti-marker"></i>
            <span>Entries</span>
          </Link>
        </li>

        <li>
          <Link to="/#" className="has-arrow waves-effect">
            <i className="ti-image"></i>
            <span>Banner</span>
          </Link>
          <ul className="sub-menu">
            <li>
              <Link to="/banner">Select banner</Link>
            </li>
            <li>
              <Link to="/banner-list">Banner list</Link>
            </li>
            <li>
              <Link to="/banner-form">Banner form</Link>
            </li>
          </ul>
        </li>

        <li>
          <Link
            to="/user-point-wise"
            onClick={() => {
              dispatch(setZero());
            }}
          >
            <i className="ti-bar-chart"></i>
            <span>User Point Wise</span>
          </Link>
        </li>

        <li>
          <Link
            to="/logs"
            onClick={() => {
              dispatch(setZero());
            }}
          >
            <i className="ti-file"></i>
            <span>Logs</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    if (this.props.type !== "condensed" || this.props.isMobile) {
      new MetisMenu("#side-menu");

      var matchingMenuItem = null;
      var ul = document.getElementById("side-menu");
      var items = ul.getElementsByTagName("a");
      for (var i = 0; i < items.length; ++i) {
        if (this.props.location.pathname === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("mm-active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active"); // li
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  render() {
    return (
      <React.Fragment>
        {this.props.type !== "condensed" ? (
          <SimpleBar style={{ maxHeight: "100%" }}>
            <SidebarContent />
          </SimpleBar>
        ) : (
          <SidebarContent />
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(Sidebar);
